import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_56 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_61 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_70 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_71 = ["required", "placeholder"]
const _hoisted_72 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = ["required", "placeholder"]
const _hoisted_77 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_78 = { class: "col-12" }
const _hoisted_79 = { class: "form-check form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_80 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "caregiver"
}
const _hoisted_81 = { class: "col-12" }
const _hoisted_82 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_85 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_86 = ["required", "placeholder"]
const _hoisted_87 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_90 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_91 = ["required", "placeholder"]
const _hoisted_92 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_96 = ["required", "placeholder"]
const _hoisted_97 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = ["required", "placeholder"]
const _hoisted_102 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_103 = {
  key: 4,
  class: "col-12"
}
const _hoisted_104 = {
  key: 5,
  class: "col-md-12"
}
const _hoisted_105 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_106 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_108 = { class: "position-relative" }
const _hoisted_109 = { key: 1 }
const _hoisted_110 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_111 = { class: "row justify-content-center" }
const _hoisted_112 = { class: "col" }
const _hoisted_113 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_select = _resolveComponent("country-select")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" CENTER_ID "),
            (!_ctx.update && (_ctx.centers ?? []).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('page.center')) + "* ", 1 /* TEXT */),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.center_id }]]),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patient.center_id) = $event)),
                        required: "",
                        disabled: _ctx.update
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centers, (center) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: center.id,
                            value: center.id
                          }, _toDisplayString(center.name), 9 /* TEXT, PROPS */, _hoisted_8))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 10 /* CLASS, PROPS */, _hoisted_7), [
                        [_vModelSelect, _ctx.patient.center_id]
                      ])
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.sex ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.sex, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ANAGRAPH "),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t('form.section.patient_information')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" FIRST NAME "),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('form.first_name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patient.firstname) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.firstname }]]),
                  required: "",
                  placeholder: _ctx.$t('form.first_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_15), [
                  [_vModelText, _ctx.patient.firstname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.firstname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.firstname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" LAST NAME "),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('form.last_name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patient.lastname) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.lastname }]]),
                  required: "",
                  placeholder: _ctx.$t('form.last_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_20), [
                  [_vModelText, _ctx.patient.lastname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.lastname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lastname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" BIRTH DATE "),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.birth_date.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patient.birthdate) = $event)),
                  type: "date",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.birthdate }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.patient.birthdate]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.birthdate ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.birthdate, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_26,
            _createCommentVNode(" SEX "),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('form.gender.label')), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.sex }]]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patient.sex) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available_genders, (gender_id) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: gender_id,
                        value: gender_id.toString()
                      }, _toDisplayString(_ctx.$t(`form.gender.${gender_id}`)), 9 /* TEXT, PROPS */, _hoisted_30))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */), [
                    [_vModelSelect, _ctx.patient.sex]
                  ])
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.sex ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.sex, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_32,
            _createCommentVNode(" ADDRESS "),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('form.address.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patient.address) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.address }]]),
                  required: "",
                  placeholder: _ctx.$t('form.address.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_36), [
                  [_vModelText, _ctx.patient.address]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.address ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.address, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" CITY "),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('form.city.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patient.city) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.city }]]),
                  placeholder: _ctx.$t('form.city.placeholder'),
                  required: ""
                }, null, 10 /* CLASS, PROPS */, _hoisted_41), [
                  [_vModelText, _ctx.patient.city]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.city ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.city, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" REGION "),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('form.region.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patient.region) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.region }]]),
                  placeholder: _ctx.$t('form.region.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_46), [
                  [_vModelText, _ctx.patient.region]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.region ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.region, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" ZIP CODE "),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('form.zip_code.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.patient.zipcode) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.zipcode }]]),
                  placeholder: _ctx.$t('form.zip_code.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_51), [
                  [_vModelText, _ctx.patient.zipcode]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.zipcode ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.zipcode, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" COUNTRY "),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('form.country.label')) + "* ", 1 /* TEXT */),
                _createVNode(_component_country_select, {
                  modelValue: _ctx.patient.country,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.patient.country) = $event)),
                  country: _ctx.patient.country,
                  class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.country }]]),
                  placeholder: _ctx.$t('form.country.placeholder'),
                  required: "",
                  whiteList: "['IT','GB','FR','ES','DE']"
                }, null, 8 /* PROPS */, ["modelValue", "country", "placeholder", "class"]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.country ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.country, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" EXTRAS "),
            _createCommentVNode(" <template v-if=\"extra_definitions !== undefined && extra_responses !== undefined\">\n            <ExtraDefinitions :extra_definitions=\"extra_definitions\" v-model:extra_responses=\"extra_responses\"\n              :submitted=\"submitted\" :errors=\"errors\"></ExtraDefinitions>\n          </template> "),
            _createCommentVNode(" CONTACTS "),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("h4", _hoisted_58, _toDisplayString(_ctx.$t('form.section.contacts')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" UPDATE (DISABLED) "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" EMAIL "),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.patient.users![0].email) = $event)),
                        type: "email",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                        required: "",
                        pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                        placeholder: _ctx.$t('form.email.placeholder'),
                        disabled: ""
                      }, null, 10 /* CLASS, PROPS */, _hoisted_62), [
                        [_vModelText, _ctx.patient.users![0].email]
                      ])
                    ])
                  ]),
                  _createCommentVNode(" PHONE "),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('form.phone.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.patient.users![0].phone_number) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }]]),
                        required: "",
                        placeholder: _ctx.$t('form.phone.placeholder'),
                        disabled: ""
                      }, null, 10 /* CLASS, PROPS */, _hoisted_66), [
                        [_vModelText, _ctx.patient.users![0].phone_number]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.phone_number ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" CREATE "),
                  _createCommentVNode(" EMAIL "),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.patient.email) = $event)),
                        type: "email",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                        required: !_ctx.patient.caregiver_account,
                        pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                        placeholder: _ctx.$t('form.email.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_71), [
                        [_vModelText, _ctx.patient.email]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.email ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createCommentVNode(" PHONE "),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('form.phone.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.patient.phone_number) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }]]),
                        required: !_ctx.patient.caregiver_account,
                        placeholder: _ctx.$t('form.phone.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_76), [
                        [_vModelText, _ctx.patient.phone_number]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.phone_number ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */)),
            _createCommentVNode(" CAREGIVER "),
            (!_ctx.update)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createCommentVNode(" ADD CAREGIVER "),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input shadow-none",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.patient.caregiver_account) = $event)),
                        onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.resetCaregiver && _ctx.resetCaregiver(...args))),
                        id: "caregiver"
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.patient.caregiver_account]
                      ]),
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('form.add_caregiver.label')), 1 /* TEXT */)
                    ])
                  ]),
                  (_ctx.patient.caregiver_account)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createCommentVNode(" CAREGIVER INFO "),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("h4", _hoisted_82, _toDisplayString(_ctx.$t('form.section.caregiver_information')), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" FIRST NAME "),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('form.first_name.label')) + "* ", 1 /* TEXT */),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.patient.caregiver_firstname) = $event)),
                              required: _ctx.patient.caregiver_account,
                              type: "text",
                              class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.caregiver_firstname }], "form-control shadow-none text-black"]),
                              placeholder: _ctx.$t('form.first_name.placeholder')
                            }, null, 10 /* CLASS, PROPS */, _hoisted_86), [
                              [_vModelText, _ctx.patient.caregiver_firstname]
                            ]),
                            _createCommentVNode(" ERRORS "),
                            (_ctx.errors?.caregiver_firstname ?? false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.caregiver_firstname, (error) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: error,
                                      class: "small text-danger lh-1 m-0 mt-1"
                                    }, _toDisplayString(error), 1 /* TEXT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" LAST NAME "),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t('form.last_name.label')) + "* ", 1 /* TEXT */),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.patient.caregiver_lastname) = $event)),
                              required: _ctx.patient.caregiver_account,
                              type: "text",
                              class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.caregiver_lastname }], "form-control shadow-none text-black"]),
                              placeholder: _ctx.$t('form.last_name.placeholder')
                            }, null, 10 /* CLASS, PROPS */, _hoisted_91), [
                              [_vModelText, _ctx.patient.caregiver_lastname]
                            ]),
                            _createCommentVNode(" ERRORS "),
                            (_ctx.errors?.caregiver_lastname ?? false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.caregiver_lastname, (error) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: error,
                                      class: "small text-danger lh-1 m-0 mt-1"
                                    }, _toDisplayString(error), 1 /* TEXT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" EMAIL "),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.patient.caregiver_email) = $event)),
                              required: _ctx.patient.caregiver_account,
                              class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.caregiver_email }], "form-control shadow-none text-black"]),
                              pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                              type: "email",
                              placeholder: _ctx.$t('form.email.placeholder')
                            }, null, 10 /* CLASS, PROPS */, _hoisted_96), [
                              [_vModelText, _ctx.patient.caregiver_email]
                            ]),
                            _createCommentVNode(" ERRORS "),
                            (_ctx.errors?.caregiver_email ?? false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.caregiver_email, (error) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: error,
                                      class: "small text-danger lh-1 m-0 mt-1"
                                    }, _toDisplayString(error), 1 /* TEXT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" PHONE "),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('form.phone.label')) + "* ", 1 /* TEXT */),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.patient.caregiver_phone_number) = $event)),
                              required: _ctx.patient.caregiver_account,
                              type: "text",
                              class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.caregiver_phone_number }], "form-control shadow-none text-black"]),
                              placeholder: _ctx.$t('form.phone.placeholder')
                            }, null, 10 /* CLASS, PROPS */, _hoisted_101), [
                              [_vModelText, _ctx.patient.caregiver_phone_number]
                            ]),
                            _createCommentVNode(" ERRORS "),
                            (_ctx.errors?.caregiver_phone_number ?? false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.caregiver_phone_number, (error) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: error,
                                      class: "small text-danger lh-1 m-0 mt-1"
                                    }, _toDisplayString(error), 1 /* TEXT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update && _ctx.destroyEnabled)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_106, [
                          _hoisted_107,
                          _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('cta.delete_patient')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_109)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_110, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$router.push({ path: _ctx.update ? `/patient/${_ctx.patient.id}` : '/patients' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_patient')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[24] || (_cache[24] = ($event: any) => (_ctx.deletePatient())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}